import { Component } from '@angular/core';

@Component({
    selector: 'app-modal-welcome',
    templateUrl: './modal-welcome.component.html',
    styleUrls: ['./modal-welcome.component.scss'],
    standalone: false
})
export class ModalWelcomeComponent {}
